<template>
  <div
    v-if="isVisible"
    data-qa="lpu_staff_admin"
  >
    <div>
      <aside id="widget_panel_container" />
    </div>
    <div>
      <form
        v-if="showDeleteDoctorsForm"
        :action="deleteDoctorsUrl"
        method="post"
        class="d-inline-block"
      >
        <input
          type="hidden"
          name="csrfmiddlewaretoken"
          :value="context.csrf_token"
        >
        <input
          type="hidden"
          name="lpu"
          :value="context.lpu.id"
        >
        <button
          type="submit"
          class="adminka"
        >
          Удалить всех врачей
          <br><br>
        </button>
      </form>
    </div>
    <div class="upload_container d-none">
      <input
        id="upload1"
        type="file"
        class="lpu-staff-admin__upload-input"
      >
    </div>
    <div id="dialog" />
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import useContextStore from 'src/store/useContextStore'
import useURLStore from 'src/store/useURLStore'
import type { ContextStore } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/index/types'
import loadLpuStaffModules from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuStaffAdmin/loadLpuStaffModules'

type StaffWindow = Window & {
  csrftoken?: string
  lpu_id?: number
  town?: string
}

const { context }: ContextStore = useContextStore()
const { reverse } = useURLStore()
const isMobile = useIsMobile()

const isStaff = computed(() => Boolean(context.request.user.is_staff))

/** Staff-панель и lpu-staff только на десктопе полной Vue-страницы. */
const isVisible = computed(() => (
  Boolean(context.request.feature_flags.ff_lpu_branding_page_v4)
  && isStaff.value
  && !context.is_lpu_branding_preview
  && !isMobile.value
))

const userGroups = computed(() => {
  const groups = (context.request as { user_groups?: string[] }).user_groups

  return Array.isArray(groups) ? groups : []
})

const showDeleteDoctorsForm = computed(() => {
  const hasSeniorGroup = userGroups.value.includes('content_senior_group')

  return hasSeniorGroup && context.lpu.town.translit === 'test'
})

const deleteDoctorsUrl = computed(() => reverse({
  name: 'delete_all_doctors_in_test_lpu',
  args: [context.lpu.id],
}))

function bindStaffGlobals() {
  const staffWindow = window as StaffWindow

  staffWindow.csrftoken = context.csrf_token || staffWindow.csrftoken || ''
  staffWindow.lpu_id = context.lpu.id
  staffWindow.town = context.town?.translit || context.lpu.town.translit
}

onMounted(() => {
  if (!isVisible.value) {
    return
  }

  bindStaffGlobals()
  loadLpuStaffModules().catch(() => {
    // Staff UI опционален: ошибка чанка не должна валить страницу.
  })
})
</script>

<style lang="scss" scoped>
.lpu-staff-admin__upload-input {
  display: none;
  width: 0;
  visibility: hidden;
}
</style>
